<template lang="html">
  <div class="exam">
    <img class="home_banner" :src="coverData.cover" alt="">
    <div class="start_btn" @click="stattBtn">
      <img class="" :src="coverData.button" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      username() {
        return this.$route.params.id
      }
    },
    data() {
      return {
        coverData: {},
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.exam();
      },
      exam() {
        this.$http({
          url: "/paper/getPaperAuthType",
          method: 'get',
          params: {
            task_id: this.$route.query.task_id,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.coverData = res.data;
            document.title = res.data.title;
          }
        })
      },
      stattBtn() {
        this.$router.replace({
          path: '/user',
          query: {
            task_id: this.$route.query.task_id,
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>
  .home_banner {
    width: 100%;
    max-width: 750px;
  }

  .start_btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    margin: auto;
    display: flex;
    justify-content: center;
  }

  .start_btn img {
    width: 18rem;
    height: 6rem;
    margin-bottom: 2rem;
    object-fit: cover;
  }
</style>